import {NgModule} from '@angular/core';
import {RouterModule} from '@angular/router';
import {ByodBrandSplashPage} from './byod-brand-splash';
import {SharedModule} from '../../shared/shared.module';
import { LanguageChoiceModule } from 'src/app/shared/components/language_choice/language_choice.module';
import { SummaryModule } from 'src/app/routes/summary/summary.module';
import { OrderRouteModule } from 'src/app/routes/order.route';
import { MemberCourtRouteModule } from 'src/app/routes/member/member-court/member-court.route';

@NgModule({
    declarations: [ByodBrandSplashPage],
    entryComponents: [ByodBrandSplashPage],
    imports: [
        SharedModule,
        SummaryModule,
        LanguageChoiceModule,
        OrderRouteModule,
        MemberCourtRouteModule,
        RouterModule.forChild([
            {
                path: '',
                component: ByodBrandSplashPage
            },
            {
                path: 'brand-store-list',
                loadChildren: '../brand-store-list/brand-store-list.module#BrandStoreListModule'
            },
            {
                path: 'dinein-takeaway',
                loadChildren: '../dinein-or-takeaway-page/dinein-or-takeaway-page.module#DineinOrTakeawayPageModule'
            }, {
                path: 'brand-faq',
                loadChildren: '../brand-faq/brand-faq.module#BrandFAQPageModule'
            },
            {
                path: '**',
                redirectTo: ''
            },
        ])
    ]
})
export class ByodBrandSplashModule {
    constructor() {
    }
}
